import { useEffect } from 'react';

import styled from '@emotion/styled';

import StartsCard from '../../../components/Cards/StartsCard';
import TrendDownIcon from '../../../components/Icons/TrendDownIcon';
import TrendUpIcon from '../../../components/Icons/TrendUpIcon';
import useTriplogStats from '../../../hooks/dashboard/trip-log/useTriplogStats';
import { useAppSelector } from '../../../redux/store';

const StatsCard = () => {
  const { getTriplogStats } = useTriplogStats();
  const { triplogStatsData } = useAppSelector(
    (state) => state.triplogStatsData,
  );
  const ratingConversionRate = triplogStatsData?.ratingConversionRate ?? 0;
  const totalVehicleReceived = triplogStatsData?.totalRatingsReceived ?? 0;
  const totalRatingsReceivedChangePercentage =
    triplogStatsData?.totalRatingsReceivedChangePercentage ?? 0;
  const totalRatingSent = triplogStatsData?.totalRatingsSent ?? 0;
  const totalRatingsSentChangePercentage =
    triplogStatsData?.totalRatingsSentChangePercentage ?? 0;

  useEffect(() => {
    getTriplogStats();
    // eslint-disable-next-line
  }, []);

  return (
    <StatsArea>
      <StartsCard.Root>
        <StartsCard.Header>TOTAL RATING SENT</StartsCard.Header>
        <StartsCard.Value>{totalRatingSent}</StartsCard.Value>
        <StartsCard.DynamicFooter trend={totalRatingsSentChangePercentage}>
          {totalRatingsSentChangePercentage >= 0 ? (
            <span>↑</span>
          ) : (
            <span>↓</span>
          )}{' '}
          {totalRatingsSentChangePercentage >= 0
            ? `+${totalRatingsSentChangePercentage}%`
            : `-${totalRatingsSentChangePercentage}%`}{' '}
          from last month
        </StartsCard.DynamicFooter>
      </StartsCard.Root>

      <StartsCard.Root>
        <StartsCard.Header>TOTAL RATING RECEIVED</StartsCard.Header>
        <StartsCard.Value>{totalVehicleReceived}</StartsCard.Value>
        <StartsCard.DynamicFooter trend={totalRatingsReceivedChangePercentage}>
          {totalRatingsReceivedChangePercentage >= 0 ? (
            <span>↑</span>
          ) : (
            <span>↓</span>
          )}{' '}
          {totalRatingsReceivedChangePercentage >= 0
            ? `+${totalRatingsReceivedChangePercentage}%`
            : `-${totalRatingsReceivedChangePercentage}%`}{' '}
          from last month
        </StartsCard.DynamicFooter>
      </StartsCard.Root>

      <StartsCard.Root>
        <StartsCard.Header>RATING CONVERSION RATE</StartsCard.Header>
        <StartsCard.DynamicValue trend={ratingConversionRate}>
          <span>
            {ratingConversionRate >= 0 ? <TrendUpIcon /> : <TrendDownIcon />}
          </span>
          <span>{Math.abs(ratingConversionRate)}%</span>
        </StartsCard.DynamicValue>
      </StartsCard.Root>
    </StatsArea>
  );
};

export default StatsCard;

const StatsArea = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;

  @media (max-width: 884px) {
    display: flex;
    flex-direction: column;
  }
`;
